import * as React from "react";
import {cx} from "emotion";

import "./past-editions.scss";

import {getCartTotalPurchaseAmount}   from "@Common/logic/cart/get-cart-total-purchase-amount";
import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {keyed}                        from "@Common/react/keyed";
import {Load}                         from "@Common/react/load";
import {UseState}                     from "@Common/react/use-state";
import {Badge}                        from "@Common/ui-components/heavy/common/design2/badge/badge";
import {formatMoney1}                 from "@Common/ui-components/language/format-money";
import {reverse, sort, toGroupsByKey} from "@Common/utils/collections";
import {parseDate}                    from "@Common/utils/date-object";
import {parseDateFormat}              from "@Common/utils/date/parse-date-format";
import {chain}                        from "@Common/utils/fs";

import {Expand1Table}              from "@Xpresso/routes/common/expand1-table/expand1-table";
import {mapCartItemToOrderDetails} from "@Xpresso/routes/common/map-cart-item-to-order-details";

import {OrderDetailsSidebar2} from "../../../../../orders/common/order-details/order-details-sidebar";

export const PastEditions = ({className, loading, program, editions2}) => cs(
    ["hide", (_, next) => UseState({next})],
    ({hide}) => (
        <div className={cx("past-editions-9np", className)}>
            <div className="header">
                <div {...{
                    className: "title",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Past Editions",
                }}>
                    Past Editions
                </div>
                {!!editions2?.length && (
                    <a {...{
                        onClick: () => hide.change(v=>!v),
                        "xd-qa-type": "link",
                        "xd-qa-name": (
                            hide.value ? (
                                "Past Editions - Show Details"
                            ) : (
                                "Past Editions - Hide Details"
                            )
                        ),
                    }}>
                        {hide.value ? (
                            "Show Details"
                        ) : (
                            "Hide Details"
                        )}
                    </a>
                )}
            </div>

            {cs(
                ({}, next) => (!hide.value || !editions2?.length) && next(),
                ({}, next) => (
                    <div className="box">
                        {next()}
                    </div>
                ),
                ({}, next) => loading ? (
                    <div className="loading">
                        Loading data...
                    </div>
                ) : (
                    next()
                ),
                consumeContext("apis"),
                ["orderDetailsSidebar", (_, next) => OrderDetailsSidebar2({next})],
                ["groupedRuns", (_, next) => next(groupRunsBySeries(editions2))],
                ({groupedRuns, apis, orderDetailsSidebar}) => (
                    Expand1Table({
                        noDataMessage: "You do not have any completed Editions",
                        noDataProps: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "You do not have any completed Editions",
                        },
                        // defaultExpanded: () => true,
                        list: groupedRuns.map(({seriesId, editions}) => ({
                            rowId: program.programPreferences.series.find((s) => s.id === seriesId)?.name,
                            key: seriesId,
                            onClick: ({expanded, setExpanded}) => setExpanded(!expanded),
                            columns: [
                                {
                                    renderCell: () => program.programPreferences.series.find((s) => s.id === seriesId)?.name,
                                    // sortValue : () => 111,
                                },
                                {
                                    renderCell: () => editions.length,
                                    // sortValue : () => 111,
                                },
                            ],
                            renderExpansion: () => cs(
                                ({}, next) => (
                                    <div className="expansion-32e">
                                        <div className="grid">
                                            {next()}
                                        </div>
                                    </div>
                                ),
                                () => (
                                    editions.map(({run, pe}) => cs(
                                        keyed(JSON.stringify({"run._id": run?._id, "pe.editionId": pe.editionId})),
                                        ({}) => (
                                            <div {...{
                                                className: cx("edition", {hasError: run?.current_state !== "COMPLETE"}),

                                                "xd-qa-type": "card",
                                                "xd-qa-name": "Edition " + pe.name,
                                            }}>
                                                <div className="line1">
                                                    <div {...{
                                                        className: "title",

                                                        "xd-qa-type": "label",
                                                        "xd-qa-name": "Edition Name",
                                                    }}>
                                                        {pe.name}
                                                    </div>
                                                </div>
                                                <div className="actions">
                                                    {run?.idOrder && !(run?.current_state === "ORDER_ERROR") && (
                                                        <a {...{
                                                            onClick: async () => {
                                                                const cart = await apis.next.cart.getCart(run.idCart);
                                                                // console.log("item", item);
                                                                orderDetailsSidebar.show({
                                                                    orderList: cart.items.map((item) => ({
                                                                        item: mapCartItemToOrderDetails(item),
                                                                        displayOrderTotal: false,
                                                                    })),
                                                                    // orderDetails: {
                                                                    //     item: mapCartItemToOrderDetails(item),
                                                                    //     displayOrderTotal: false,
                                                                    //     // displayOrderTotal: true,
                                                                    // },
                                                                });
                                                            },
                                                            "xd-qa-type": "link",
                                                            "xd-qa-name": "Edition Details",
                                                        }}>
                                                            Details
                                                        </a>
                                                    )}
                                                </div>

                                                {run?.current_state !== "COMPLETE" ? <>
                                                    {cs(
                                                        ["message", (_, next) => next(
                                                            run?.current_state === "FAILED" ? (
                                                                "Failed"
                                                            ) : run?.current_state === "ORDER_ERROR" ? (
                                                                "Order Failed"
                                                            ) : (
                                                                "Error"
                                                            )
                                                        )],
                                                        ({message}) => Badge({
                                                            color: "red",
                                                            message: <>
                                                                <i className="fa fa-exclamation-triangle"/>

                                                                {message}
                                                            </>,
                                                            xdQaName: message,
                                                        })
                                                    )}

                                                    <div {...{
                                                        className: "error-message",

                                                        "xd-qa-type": "text",
                                                        "xd-qa-name": "Error Message",
                                                    }}>
                                                        {run?.current_state === "ORDER_ERROR" ? (
                                                            "Order Failed - Please Contact Support"
                                                        ) : run ? (
                                                            run.current_state_info
                                                        ) : (
                                                            "ERROR: No run data"
                                                        )}
                                                        {/*{"Update your preferred payment method to complete the order"}*/}
                                                    </div>
                                                </> : cs(
                                                    consumeContext("apis"),
                                                    ["cart", ({apis}, next) => Load({
                                                        disabled: !run?.idCart,
                                                        fetch: () => apis.next.cart.getCart(run.idCart),
                                                        next,
                                                    })],
                                                    ({cart}) => (
                                                        <div className="details-train">
                                                            <div className="car">
                                                                <div {...{
                                                                    className: "label",

                                                                    "xd-qa-type": "label",
                                                                    "xd-qa-name": "Checkout Completed",
                                                                }}>
                                                                    Checkout Completed
                                                                </div>
                                                                <div {...{
                                                                    className: "value",
                                                                    "xd-qa-type": "text",
                                                                    "xd-qa-name": "Checkout Completed",
                                                                }}>
                                                                    {cart && parseDateFormat("MMMM dd, yyyy").formatDate(parseDate(new Date(cart.date_modified.date)))}
                                                                </div>
                                                            </div>
                                                            <div className="car">
                                                                <div {...{
                                                                    className: "label",
                                                                    "xd-qa-type": "label",
                                                                    "xd-qa-name": "Charged",
                                                                }}>
                                                                    Charged
                                                                </div>
                                                                <div {...{
                                                                    className: "value",
                                                                    "xd-qa-type": "text",
                                                                    "xd-qa-name": "Charged",
                                                                }}>
                                                                    {cart && formatMoney1(getCartTotalPurchaseAmount(cart))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ),
                                                )}

                                            </div>
                                        )
                                    ))
                                ),
                            ),
                            xdQaType: "card",
                            xdQaName: "Past Editions Series",
                        })),
                        columns: [
                            {
                                label: "EDITION",
                                xdQaName: "EDITION",
                                sorting: {disabled: true},
                            },
                            {
                                label: "ITEMS",
                                xdQaName: "ITEMS",
                                align: "right",
                                sorting: {disabled: true},
                            },
                        ],
                    })
                ),
            )}
        </div>
    ),
);

const groupRunsBySeries = (editions) => {
    const groups = toGroupsByKey(editions, ({pe}) => pe.seriesId);
    return chain(
        Object.keys(groups),
        (_) => sort(_, (seriesId) => {
            return groups[seriesId][0].pe.enrollmentDeadline;
        }),
        reverse,
        // console.log,
        (_) => _.map((seriesId) => ({
            seriesId,
            editions: groups[seriesId],
        })),
    );
};

